import React, { useEffect, useState } from "react";
import Departmentmaster from "./Departmentmaster";
import Designationmaster from "./Designationmaster";
import Holidaymaster from "./Holidaymaster";
import Header from "../../Header";
import { useSelector } from "react-redux";
import { SystemAdminProfile } from "../../../Repository/Api";
import { errorMsg } from "../../Toastify";
import Sidebar from "../../Sidebar";
import Leavemaster from "./Leavemaster";
import Responsemessage from "./Responsemessage";

const Masterdata = () => {
  const { first_name, last_name, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const [selectedTab, setSelectedTab] = useState("Department Master");
  const AllTabs = [
    "Department Master",
    "Designation Master",
    "Holiday Master",
    "Leave Master",
    "Response Message",
  ];

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} {last_name}
                </h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="main">
                  <div className="heading-content-bg d-flex justify-content-center align-items-center">
                    <h5 className="mb-0 font-bold">Master Data</h5>
                  </div>
                  <div className="container">
                    <div className="my-3 row">
                      <div className="col-lg-2 px-0">
                        {AllTabs.map((tab, index) => {
                          return (
                            <div key={index} className="mb-2">
                              <button
                                type="button"
                                className={
                                  selectedTab === tab
                                    ? "btn w-100 text-start add-btn-active"
                                    : "btn w-100 text-start add-btn-inactive"
                                }
                                onClick={() => setSelectedTab(tab)}
                              >
                                {tab}
                              </button>
                            </div>
                          );
                        })}
                      </div>
                      <div className="col-lg-10 px-0">
                        {selectedTab === "Department Master" && (
                          <Departmentmaster />
                        )}
                        {selectedTab === "Designation Master" && (
                          <Designationmaster />
                        )}
                        {selectedTab === "Holiday Master" && <Holidaymaster />}
                        {selectedTab === "Leave Master" && <Leavemaster />}
                        {selectedTab === "Response Message" && (
                          <Responsemessage />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Masterdata;
